import { useEffect, useRef, useState } from 'react';
import { buildStandaloneSearchBox, StandaloneSearchBoxAnalytics, StandaloneSearchBoxState } from '@coveo/headless';
import { useCoveoSearchEngine } from '../CoveoSearchEngine';
import { SearchSuggestionInputSlideout } from './SearchSuggestionInputSlideout';
import globalConfig from '../../../Data/globalConfig.json';
import { GlobalSearchLocalStorageName } from '../Helpers/AppHelper';
import { BusinessHelper } from 'Foundation/Common/BusinessHelper';
import { useUserData } from 'Foundation/User/UserContext';
import { useNavigate } from 'react-router-dom';
import { getCoveoSearchPageUrl } from 'Foundation/Configurations/GlobalConfiguration';

interface StandaloneSearchBoxProps {
  id: string;
  redirectionUrl: string;
  showSearch?: boolean;
  onOpen?: (isOpen: boolean) => void;
}
export function StandaloneSearchBoxSlideout(props: StandaloneSearchBoxProps) {
  const { headlessEngine } = useCoveoSearchEngine();
  let navigate = useNavigate();
  const { userData } = useUserData();
  const standaloneSearchBox = useRef(
    buildStandaloneSearchBox(headlessEngine!, {
      options: {
        redirectionUrl: props.redirectionUrl,
        id: props.id,
      },
    }),
  );
  const [standaloneSearchBoxState, setStandaloneSearchBoxState] = useState<StandaloneSearchBoxState>(
    standaloneSearchBox.current.state,
  );
  const searchLabelText = userData?.isPL() ? 'Search site content only' : 'Enter search term';

  useEffect(() => {
    const unsub = standaloneSearchBox.current.subscribe(() =>
      setStandaloneSearchBoxState(standaloneSearchBox.current.state),
    );
    return function cleanup() {
      unsub();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onSubmit = () => {
    const { value, analytics } = standaloneSearchBoxState;
    triggerSearch(value, analytics);
  };
  const triggerSearch = (value: string, analytics: StandaloneSearchBoxAnalytics | {}) => {
    const data = JSON.stringify({ value, analytics });
    localStorage.setItem(GlobalSearchLocalStorageName, data);
    if (BusinessHelper.IsCustomerLookup(value) && userData?.isPL()) {
      navigate(`${globalConfig.CustomerSearch.path}?searchTerm=${value}`);
    } else {
      standaloneSearchBox.current.submit();
      window.location.assign(getCoveoSearchPageUrl());
    }
  };
  const onChange = (value: string) => {
    standaloneSearchBox.current.updateText(value);
  };

  const onSuggestionClick = (value: string) => {
    standaloneSearchBox.current.selectSuggestion(value);
    standaloneSearchBox.current.submit();
    triggerSearch(value, {});
  };

  return (
    <>
      {standaloneSearchBoxState && (
        <div className="standalone-search-slideout-wrapper mobile-search-icon-container">
          <SearchSuggestionInputSlideout
            label={searchLabelText}
            state={standaloneSearchBoxState}
            onChange={onChange}
            onSubmit={onSubmit}
            onOpen={props.onOpen}
            onSuggestionClick={onSuggestionClick}
            showSuggestions={true}
            showSearch={props.showSearch}
          />
        </div>
      )}
    </>
  );
}
